export default __webpack_public_path__ + "static/media/PlayH4.dedaa188.png";